import Container from "./CustomerContainer";
import Store from "./CustomerStore";

export default Store(Container);
